import { differenceInDays } from 'date-fns';
import { titleConcat, descLimit } from '@/utils/meta';
import { CLIENT_URI } from '@/constants/urls';
import { usePathname } from '@/i18n/routing';
import { useSearchParams } from 'next/navigation';

export const Schema = ({ data }) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  if (!data) {
    return null;
  }

  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'Apartment',
    additionalType: 'http://www.productontology.org/id/Apartment',
    name: titleConcat(data.name),
    description:
      descLimit(data.description) || descLimit(t('main.meta.description')),
    image:
      data.previewImages && data.previewImages.length
        ? data.previewImages[0].url
        : undefined,
    numberOfBedrooms: data.occupancy?.numBeds,
    petsAllowed: `${data.occupancy?.petsAllowed ? 'true' : 'false'}`,
    amenityFeature: [
      ...(data.featuredAmenities && data.featuredAmenities.length
        ? data.featuredAmenities.map((amentity) => ({
            '@type': 'LocationFeatureSpecification',
            name: amentity.name,
          }))
        : []),
      ...(data.regularAmenities && data.regularAmenities.length
        ? data.regularAmenities.map((amentity) => ({
            '@type': 'LocationFeatureSpecification',
            name: amentity.name,
          }))
        : []),
    ],
    occupancy: {
      '@type': 'QuantitativeValue',
      minValue: 1,
      maxValue: data.occupancy?.numGuests,
    },
    leaseLength: data.price
      ? {
          '@type': 'QuantitativeValue',
          value:
            differenceInDays(
              new Date(data.price.endDate),
              new Date(data.price.startDate)
            ) || 1,
          unitText: 'night',
        }
      : undefined,
    offer: data.price?.regular
      ? {
          '@type': 'Offer',
          availability: 'https://schema.org/InStock',
          price: data.price.regular.totalPrice,
          priceCurrency: 'SEK',
          availabilityStarts: data.price.startDate,
          availabilityEnds: data.price.endDate,
        }
      : {
          '@type': 'Offer',
          url:
            data.availabilityPeriods && data.availabilityPeriods.length
              ? `${CLIENT_URI}${pathname}?startDate=${data.availabilityPeriods[0].startDate}&endDate=${data.availabilityPeriods[0].endDate}`
              : `${CLIENT_URI}${pathname}?${searchParams}`,
        },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: `[${JSON.stringify(schema)}]` }}
    />
  );
};
